/**
 * InlineEmptyState
 * Simple empty state message for use within panels and sections
 */

import { makeStyles, tokens, Text, mergeClasses } from '@fluentui/react-components'

const useStyles = makeStyles({
  root: {
    padding: tokens.spacingVerticalL,
    textAlign: 'center',
    color: tokens.colorNeutralForeground3,
  },
  withBackground: {
    backgroundColor: tokens.colorNeutralBackground2,
    borderRadius: tokens.borderRadiusMedium,
  },
})

export interface InlineEmptyStateProps {
  message: string
  withBackground?: boolean
}

export function InlineEmptyState({ message, withBackground = false }: InlineEmptyStateProps) {
  const styles = useStyles()

  return (
    <div className={mergeClasses(styles.root, withBackground && styles.withBackground)}>
      <Text>{message}</Text>
    </div>
  )
}
